export default __webpack_public_path__ + "static/bg-top-new-97de4984798cfe2e0133b3e6f846433e.jpg";